import { RedoIncrementDecrement } from "@redotech/redo-web/arbiter-components/increment-decrement/redo-increment-decrement";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const freightSettingsForm = groupInput({
  freightEnabled: input<boolean>(),
  spreadPercentage: input<number>(),
});

export type FreightSettingsForm = InputSchema.Input<typeof freightSettingsForm>;

export type FreightSettingsValue = InputSchema.Value<
  typeof freightSettingsForm
>;

export const freightSettingsDefault: FreightSettingsValue = {
  freightEnabled: true,
  spreadPercentage: 12,
};

export const FreightSettingsCard = memo(function FreightSettingsCard({
  input,
  isOmsEngineer,
}: {
  input: OutboundLabelForm;
  isOmsEngineer: boolean;
}) {
  const { freightSettings } = input.inputs;

  return (
    <Card title="Freight settings" w="full">
      <Flex dir="column" gap="md">
        <RedoToggle
          label="Enable freight"
          setValue={freightSettings.inputs.freightEnabled.setValue}
          size="sm"
          value={freightSettings.inputs.freightEnabled.value}
        />
        <RedoIncrementDecrement
          disabled={!isOmsEngineer}
          label="Spread percentage"
          min={0}
          setValue={freightSettings.inputs.spreadPercentage.setValue}
          step={1}
          value={freightSettings.value.spreadPercentage}
        />
      </Flex>
    </Card>
  );
});
